__turbopack_context__.v({
  "address": "AgencyHalfTextHalfMap-module-scss-module__ayRwJG__address",
  "agencyHalfTextHalfMap": "AgencyHalfTextHalfMap-module-scss-module__ayRwJG__agencyHalfTextHalfMap",
  "agencyHalfTextHalfMapSection": "AgencyHalfTextHalfMap-module-scss-module__ayRwJG__agencyHalfTextHalfMapSection",
  "mapContainer": "AgencyHalfTextHalfMap-module-scss-module__ayRwJG__mapContainer",
  "mapSection": "AgencyHalfTextHalfMap-module-scss-module__ayRwJG__mapSection",
  "mapWrapper": "AgencyHalfTextHalfMap-module-scss-module__ayRwJG__mapWrapper",
  "textSection": "AgencyHalfTextHalfMap-module-scss-module__ayRwJG__textSection",
});
